__webpack_require__.p = "../Astri_develop/";